import { ReactElement, SyntheticEvent } from 'react';

export interface LinkOptions {
  nextPanel(event: SyntheticEvent): void;
  isActive: boolean;
  isLast: boolean;
  variant: 'mobile' | 'desktop';
}
export interface ButtonOptions {
  nextTab(): void;
  isActive: boolean;
  isLast: boolean;
}

export interface FlatTree {
  id: number;
  order: number;
  parent: number | null;
  root: number | null;
  name: string;
  level: number;
  link(props: LinkOptions): ReactElement;
  button(props: ButtonOptions): ReactElement;
  related: number | null;
  renderInitial: boolean;
}

export const isLast = (flatTree: FlatTree[], id: number): boolean => !!itemsByParent(flatTree, id).length === false;

export const itemsByParent = (flatTree: FlatTree[], id: number): FlatTree[] =>
  flatTree.filter((item: FlatTree) => item.parent === id);

export const itemsByLevel = (flatTree: FlatTree[], level: number): FlatTree[] =>
  flatTree.filter((item: FlatTree) => item.level === level);

export const calcMaxLevelFromTree = (flatTree: FlatTree[]): number =>
  flatTree.reduce((max, item) => Math.max(max, item.level), 0);
